export default __webpack_public_path__ + "static/media/RESUME.5c12dd05.png";